<template>
<fieldset class="mb-3">
  <legend>{{ $t('js.backend.campaign_selector.template') }}</legend>
  <div class="mb-3">
    <label for="campaign_template_id" class="sr-only">
      {{ $t('js.backend.campaign_selector.template') }}
    </label>
    <select id="campaign_template_id" name="campaign[template_id]" v-model="selectedCopy" class="form-select">
      <option></option>
      <option v-for="template in templates" :value="template.id">{{ template.name }}</option>
    </select>
  </div>

  <div>
    <div v-if="selectedTemplate">
      <div class="my-2"><b>{{ $t('js.backend.campaign_selector.template_preview') }}</b></div>

      <div v-if="type === 'SMS'" class="p-3 bg-light border" style="width: 250px; border-radius: 10px">
        <div class="mb-3" style="white-space: pre-wrap;">{{ selectedTemplate.message }}</div>
        <div class="float-end mt-n3 mb-2 ms-2" v-tooltip="$t('js.tooltips.estimated_sms_parts')">
          {{ selectedTemplate.data.estimated_size }}
          <i class="fas fa-comment-alt"></i>
        </div>
      </div>
      <div v-else class="border rounded border p-3" style="max-height: 400px;overflow:auto">
        <b>{{ $t('js.backend.campaign_selector.subject') }}:</b> {{ selectedTemplate.subject }}<br>
        <hr>
        <div style="white-space: pre-wrap;" v-html="selectedTemplate.message"></div>
      </div>
    </div>
  </div>
</fieldset>
</template>

<script>

export default {
  name: "CampaignTemplateSelector",
  props: {
    templates: Array,
    selected: Number,
    type: String
  },
  data() {
    return {
      selectedCopy: this.selected
    }
  },
  computed: {
    selectedTemplate() {
      if (this.selected === null)
        return null

      return this.templates.find(t => t.id === this.selected)
    }
  }
}
</script>